import * as types from "./mutation-type";
import { getTasksQuery,getStoreTasksQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getTasks({ commit }, variables = {}) {
    try {
      commit(types.GET_TASKS_BEGIN);
      const {
        data: { data }

      } = await gqlClient.query({
        query     : variables.isStoreTaskView ? getStoreTasksQuery :  getTasksQuery,
        variables : variables
      });
      commit(types.GET_TASKS_SUCCESS, variables.isStoreTaskView ? data.store.tasks : data.company.tasks);
    } catch (e) {
      commit(types.GET_TASKS_ERROR, e);
    }
  },
  async deleteTask({ commit }, id) {
    try {
      commit(types.DELETE_TASK_BEGIN);
      await api.task.deleteTask(id);

      commit(types.DELETE_TASK_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_TASK_ERROR, e);
    }
  },

  async createTask({ commit }, variables ) { 
    try {
      commit(types.CREATE_TASK_BEGIN)
      const { data } = await api.task.addTask(variables)
      commit(types.CREATE_TASK_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_TASK_ERROR, e)
    }
  },
  async updateTask({ commit }, { id, data }){
    commit(types.UPDATE_TASK_BEGIN)
    try {
      const { data : updatedData } = await api.task.update(id, data)
      commit(types.UPDATE_TASK_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_TASK_ERROR, error)
    }
  },


  //assign task position to particular task
  async createTaskPosition({ commit, rootState }, taskAssignment) { 
    try {
      commit(types.ADD_TASK_POSITION_BEGIN, taskAssignment.positionId)
      const { data } = await api.taskPosition.addTaskPosition(taskAssignment)
      commit(types.ADD_TASK_POSITION_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_TASK_POSITION_ERROR, { err, positionId : taskAssignment.positionId })
    }
  },

  //un-assign task position to particular task
  async deleteTaskPosition({ commit, rootState }, { id, positionId }) {
    try {
      commit(types.DELETE_TASK_POSITION_BEGIN, positionId);
      await api.taskPosition.deleteTaskPos(id);
      commit(types.DELETE_TASK_POSITION_SUCCESS, { positionId, rootState });
    } catch (err) {
      commit(types.DELETE_TASK_POSITION_ERROR, { err, positionId });
    }
  },

  //assign task exemption to particular task
  async createTaskExemption({ commit, rootState }, taskAssignment) { 
    try {
      commit(types.ADD_TASK_EXEMPTION_BEGIN, taskAssignment.exemptionId)
      const { data } = await api.taskExemption.addTaskExemption(taskAssignment)
      commit(types.ADD_TASK_EXEMPTION_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_TASK_EXEMPTION_ERROR, { err, exemptionId : taskAssignment.exemptionId })
    }
  },
  
  //un-assign task exemption to particular task
  async deleteTaskExemption({ commit, rootState }, { id, exemptionId }) {
    try {
      commit(types.DELETE_TASK_EXEMPTION_BEGIN, exemptionId);
      await api.taskExemption.deleteTaskExemp(id);
      commit(types.DELETE_TASK_EXEMPTION_SUCCESS, { exemptionId, rootState });
    } catch (err) {
      commit(types.DELETE_TASK_EXEMPTION_ERROR, { err, exemptionId });
    }
  },

  //assign task skill to particular task
  async createTaskSkill({ commit, rootState }, taskAssignment) { 
    try {
      commit(types.ADD_TASK_SKILL_BEGIN, taskAssignment.skillId)
      const { data } = await api.taskSkill.addTaskSkill(taskAssignment)
      commit(types.ADD_TASK_SKILL_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_TASK_SKILL_ERROR, { err, skillId : taskAssignment.skillId })
    }
  },
  
  //un-assign task skill to particular task
  async deleteTaskSkill({ commit, rootState }, { id, skillId }) {
    try {
      commit(types.DELETE_TASK_SKILL_BEGIN, skillId);
      await api.taskSkill.deleteTaskSkill(id);
      commit(types.DELETE_TASK_SKILL_SUCCESS, { skillId, rootState });
    } catch (err) {
      commit(types.DELETE_TASK_SKILL_ERROR, { err, skillId });
    }
  }
};

export default actions;
